import React, { useState } from "react";
import * as XLSX from "xlsx";
import { openInAppTab } from "../../../utils/tabNavigation";

function PendingRevenue({ pendingData, onClose }) {
  console.log("pendingData", pendingData);

  const dataLog = Array.isArray(pendingData)
    ? pendingData
    : pendingData?.pending_2nd_retainer || [];

const [selectedRoleManager, setSelectedRoleManager] = useState("");

const roleManagers = [
  ...new Set(
    dataLog
      .map((item) => item.bu_head)
      .filter(Boolean)
  ),
];

const filteredData = selectedRoleManager
  ? dataLog.filter(
      (item) => item.bu_head === selectedRoleManager
    )
  : dataLog;

 const totalAmount = filteredData.reduce(
  (sum, item) =>
    sum +
    Number(item.amount || 0) *
      Number(item.conversion_rate || 1),
  0
);

  // Excel Download
  const downloadExcel = () => {
    const excelData = filteredData.map((item, index) => ({
      Sr_No: index + 1,
      Client: item.client,
      Role: item.role,
      Status: item.status,
      BU_Head: item.bu_head,
      First_Retainer_Raised: item.raised_date || "-",
      First_Retainer_Issued: item.issue_date || "-",
      Amount:
        Number(item.amount || 0) *
        Number(item.conversion_rate || 1),
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Pending Revenue",
    );

    XLSX.writeFile(
      workbook,
      "2nd_Retainer_Not_In_PINE.xlsx",
    );
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ background: "rgba(0,0,0,0.4)" }}
    >
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">

          <div className="modal-header">
            <div className="w-100 d-flex justify-content-between align-items-center">

              {/* LEFT SIDE */}
              <h6
                className="modal-title text-capitalize mb-0"
                style={{ fontSize: "16px", fontWeight: "600" }}
              >
                2nd Retainer Not in PINE
              </h6>

              {/* RIGHT SIDE */}
              <div className="d-flex align-items-center gap-3">

                <small
                  className="fw-bold"
                  style={{ fontSize: "14px" }}
                >
                  Total Revenue : ₹{" "}
                  {totalAmount.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}
                </small>

<select
  className="form-select form-select-sm"
  style={{ width: "220px" }}
  value={selectedRoleManager}
  onChange={(e) =>
    setSelectedRoleManager(e.target.value)
  }
>
  <option value="">All Role Managers</option>

  {roleManagers.map((manager) => (
    <option key={manager} value={manager}>
      {manager}
    </option>
  ))}
</select>

                {/* Excel Download */}
                <button
                  type="button"
                  className="btn btn-sm btn-success"
                  onClick={downloadExcel}
                >
                  Export Excel
                </button>

                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                ></button>

              </div>
            </div>
          </div>

          <div className="modal-body">
            {filteredData.length === 0 ? (
              <div className="text-center text-muted py-4">
                No pending revenue found
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-sm table-hover table-bordered align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Client</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th>BU Head</th>
                      <th>1st Ret Raised</th>
                      <th>1st Ret Issued</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredData.map((item, index) => {
                      const amount =
                        Number(item.amount || 0) *
                        Number(item.conversion_rate || 1);

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>

                          <td>
                            <a
                              href={`/client/view/${item.company_id}`} onClick={(e) => { e.preventDefault(); openInAppTab(`/client/view/${item.company_id}`); }}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {item.client}
                            </a>
                          </td>

                          <td>
                            <a
                              href={`/role/view/${item.role_id}`}
                              target="_blank"
                              rel="noreferrer"
                              onClick={(event) => {
                                event.preventDefault();
                                openInAppTab(
                                  `/role/view/${item.role_id}`,
                                );
                              }}
                            >
                              {item.role}
                            </a>
                          </td>

                          <td>
                            <span
                              className={`badge ${
                                item.status === "Active"
                                  ? "bg-success"
                                  : item.status === "On Hold"
                                    ? "bg-warning text-dark"
                                    : item.status === "Closed"
                                      ? "bg-danger"
                                      : "bg-secondary"
                              }`}
                            >
                              {item.status}
                            </span>
                          </td>

                          <td>{item.bu_head}</td>

                          <td>{item.raised_date || "-"}</td>

                          <td>{item.issue_date || "-"}</td>

                          <td className="text-end fw-bold">
                            ₹{" "}
                            {amount.toLocaleString("en-IN", {
                              maximumFractionDigits: 0,
                            })}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>

                  <tfoot className="table-light">
                    <tr>
                      <th colSpan="7" className="text-end">
                        Total
                      </th>

                      <th className="text-end">
                        ₹{" "}
                        {totalAmount.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })}
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}

export default PendingRevenue;
